import { IBaseSearchRequest } from "src/app/core/models/base";
import { IBase } from "src/app/core/models/base";

export interface ICreateFlexTimeCorrectionRequest {
    date:       Date;
    hours:      string;
    employeeId: string;
    description?: string;
    flexTimeCorrectionType: FlextimeCorrectionType;
    affectsOvertime: boolean;
}

export interface IFlexTimeCorrection extends IBase {
    date:       Date;
    hours:      string;
    employeeId: string;
    description: string;
    flexTimeCorrectionType: FlextimeCorrectionType;
    affectsOvertime: boolean;
}

export interface ISearchFlexTimeCorrectionsRequest extends IBaseSearchRequest {
    employeeId?: string;
}

export enum FlextimeCorrectionType {
    InitialPositiv = 0, // Increase
    InitalNegativ = 10, // Reduction
    Payout = 20, // Reduction
    IncreaseFlexTime = 30 // Increase
  }
